// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3fYmV","head":"ProcedureTableInfo_head__3y-eT"};